<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{title}}</div>
        </div>
        <div class="cotainer quickBuyCoins">
            <div class="copy-box" v-show="isAddress == 1">
                <input type="text" v-model="address">
                <img class="btn-copy" src="@/assets/fuzhi.png" @click="copy($event)" alt="">
            </div>
            <div class="cont" v-html="cont"></div>
            <button v-show="target_url" class="btn-buy btn-bg" type="button" @click="jump(target_url)">{{$t('kjmb.ljmb')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'quicklyBuyCoinsDetail',
    data () {
        return {
            id: '',
            title: '',
            cont: '',
            address: '',
            isAddress: '',
            target_url: ''
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
       this.getQuick()
    },
    methods: {
       back(){
           this.$router.push('/quicklyBuyCoins')
       },
       getQuick(){
           let params = {
                id: this.id
            }
            this.$ajax.get('/web/getQuick',{params}).then((res) => {
                let resData = res.data.data;
                this.title = resData.title;
                this.cont = this.contHtml(resData.content);
                this.address = resData.buy_address;
                this.isAddress = resData.show_address;
                this.target_url = resData.target_url;
            }).catch(function(err){
                console.log(err)
            })
        },
        jump(link){
            if(link){
                window.open(link)
            }
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
        copy(e){
            let address = this.address;
            this.$copyText(address, this.$t('kjmb.fzcg'));
            this.$toast.center(this.$t('kjmb.fzcg'));
        },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
      padding: 0 .8rem;
      font-size: .48rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        left: .48rem;
        right: .48rem;
        top: 1.6rem;
        bottom: 2.4rem;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .copy-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.08rem;
        margin: .48rem 0 0;
        padding: 0 .3rem;
        background: #fff;
    }
    .copy-box .btn-copy{
        width: .72rem;
        height: .72rem;
    }
    .cotainer .cont{
        padding: .48rem 0;
        color: #7f7f7f;
        font-size: .42rem;
    }
    .cotainer .btn-buy{
        position: fixed;
        left: .48rem;
        right: .48rem;
        bottom: .84rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/quicklyBuyCoinsDetail.vue